var map = {
	"./blue.png": "595d",
	"./blue1.png": "95b5",
	"./fall.png": "3cd0",
	"./gray.png": "366c",
	"./gray1.png": "ea10",
	"./have.png": "fe85",
	"./no.png": "d287",
	"./red.png": "c6a1",
	"./red1.png": "3fef",
	"./state.png": "c2fd",
	"./switch.png": "2e82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a94b";